// dependencies
import React from "react";

import { faSpinnerThird } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// styles
import css from "./ThumbSwitch.module.scss";

type ThumbSwitchProps = {
	value: boolean;
	isLoading?: boolean;
	onChange?: (value: boolean) => void;
	size?: "regular" | "small";
};

/**
 *
 * @deprecated Use the Toggle component from the py-components package instead.
 */
const ThumbSwitch = (props: ThumbSwitchProps) => {
	const { value, isLoading = false, onChange = () => {}, size = "regular" } = props;

	return (
		<div>
			<div
				data-testid={value ? "main-istrue" : "main-isfalse"}
				className={`${value ? css.isTrue : css.isFalse}`}
				onClick={() => onChange && onChange(!value)}
			>
				<div className={css.checkbox} />
				<div className={`${css.label} ${size === "regular" ? css.regular : css.small}`}>
					{isLoading ? (
						<div className={css.loadingIcon} data-testid="spinner">
							<FontAwesomeIcon icon={faSpinnerThird} spin />
						</div>
					) : (
						<div className={css.ball} />
					)}
					{size === "regular" ? <div className={css.onLabel}>{value ? "on" : ""}</div> : null}
					{size === "regular" ? <div className={css.offLabel}>{!value ? "off" : ""}</div> : null}
				</div>
			</div>
		</div>
	);
};

/** @deprecated Use the Toggle component from the py-components package instead. */
export default ThumbSwitch;
